// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@cahaba/Overrides/Widgets/Common/HeaderSignIn";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerSignInStyles.signOutWrapper = {
    css: css`
        display: flex;
        height: 100%;
        align-items: center;
    `,
};

headerSignInStyles.titleClickable = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    `,
};

headerSignInStyles.titleIcon = {
    size: 14,
    color: "primary.contrast",
    css: css`
        margin-right: 10px;
        path {
            fill: ${getColor("primary.contrast")};
        }
    `,
};
headerSignInStyles.titleTypography = {
    css: css`
        text-align: left;
        display: block;
        max-width: 160px;
        letter-spacing: 1px;
    `,
    size: 14,
    color: "primary.contrast",
    ellipsis: true,
    transform: "uppercase",
    weight: "normal",
};
headerSignInStyles.signOutClickable = {
    css: css`
        flex: 0 0 auto;
        margin-left: 16px;
        text-transform: none;
    `,
};
headerSignInStyles.headerSignInItemContainer = {
    css: css`
        flex: 0 0 100%;
        display: flex;
        width: 100%;
        text-align: left;
        justify-content: center;
        align-items: center;
    `,
};
